export var data = [
  {
    editor_code: "cpp",
    id: 53,
    name: "C++ (GCC 8.3.0)",
    code: `\n#include <bits/stdc++.h>\nusing namespace std;\n\nint main() {\n\t// your code goes here\n\tcout<<"Hello World";\n\treturn 0;\n}\n\n`,
  },
  {
    editor_code: "cpp",
    id: 49,
    name: "C (GCC 8.3.0)",
    code: '\n#include <stdio.h>\n\nint main(void) {\n\t// your code goes here\n\tprintf("Hello World");\n\treturn 0;\n}\n\n',
  },
  {
    editor_code: "go",
    id: 60,
    name: "Go (1.13.5)",
    code: '\npackage main\nimport "fmt"\n\nfunc main(){\n\t// your code goes here\n\tfmt.Println("Hello World")\n}\n\n',
  },
  {
    editor_code: "java",
    id: 62,
    name: "Java (OpenJDK 13.0.1)",
    code: '/*package whatever //do not write package name here*/\nimport java.util.*;\nimport java.lang.*;\nimport java.io.*;\n\n/* Name of the class has to be "Main" only if the class is public. */\nclass Main\n{\n\tpublic static void main (String[] args) throws java.lang.Exception\n\t{\n\t\t// your code goes here\n\t\tSystem.out.println("Hello World");\n\t}\n}\n\n',
  },
  {
    editor_code: "javascript",
    id: 63,
    name: "JavaScript (Node.js 12.14.0)",
    code: '\nconsole.log("Hello World")\n',
  },
  {
    editor_code: "python",
    id: 70,
    name: "Python (2.7.17)",
    code: '\ndef main():\n    # Your code goes here\n\tprint("Hello World")\n    \nif __name__ == "__main__":\n    main()\n\n',
  },
  {
    editor_code: "python",
    id: 71,
    name: "Python (3.8.1)",
    code: '\ndef main():\n    # Your code goes here\n\tprint("Hello World")\n    \nif __name__ == "__main__":\n    main()\n\n',
  },
];
